import { classNames } from "@/lib/util";

import "./Loader.scss";

type Props = {
    class_name?: string;
    message?: string;
    small?: boolean;
};

const Loader = ({ class_name, message, small }: Props) => {
    return (
        <div
            className={classNames("loading-animation", class_name, {
                "loading-animation--small": small,
            })}
        >
            <h2 className="text-center">{message}</h2>
            <div className="loader-slot">
                <div className="loader" />
            </div>
        </div>
    );
};

export default Loader;
